import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar.component';
import { NavItemModule } from 'src/app/common/utilities/nav-item/nav-item/nav-item.module';
import { ToggleModule } from 'src/app/common/utilities/toggle/toggle/toggle.module';
// import { NavItemModule } from 'src/app/common/utilities/nav-item/nav-item.module';
// import { ToggleModule } from 'src/app/common/utilities/toggle/toggle.module';



@NgModule({
  declarations: [
    SidebarComponent
  ],
  imports: [
    CommonModule,NavItemModule,ToggleModule
  ],
  exports: [
    SidebarComponent
  ]

})
export class SidebarModule { }
